import React from "react";

function CallToAction({ titleId, kicker, title, description, action }) {
  return (
    <section className="section-ms" aria-labelledby={titleId}>
      <div className="section-ms-inner primary-cta">
        <div>
          <p className="section-ms-kicker">{kicker}</p>
          <h2 id={titleId}>{title}</h2>
          <div>{description}</div>
        </div>
        {action}
      </div>
    </section>
  );
}

export default CallToAction;
